import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GruppoRami } from 'src/app/models/gruppo-rami';
import { BaseEditForm } from 'src/app/shared/baseEditForm';

@Component({
  selector: 'edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditGruppoRamiComponent extends BaseEditForm implements OnInit {

  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<EditGruppoRamiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: GruppoRami,) {
    super();
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.data?.nome, Validators.required],
      descrizione: [this.data?.descrizione,],
    });
  }

}

